<template>
    <div class="box-content px-[8px] relative overflow-hidden">
        <h3 class="absolute text-sm md:text-lg top-2 left-4 md:top-10 md:left-10 font-semibold uppercase text-teal-500 font-sans">news</h3>
        <div class="flex gap-[8px] md:gap-3 w-fit mx-auto flex-row mt-4 md:mt-0 justify-center overflow-hidden bg-white relative z-10 px-2">
            <h3 data-aos="fade-left" data-aos-duration="1000" class="mb-0 text-6xl lg:text-8xl text-prime-color text-center"><i>HUET's</i></h3>
            <h3 data-aos="fade-right" data-aos-duration="1000" class="mb-0 text-6xl lg:text-8xl text-prime-color text-center"><i>News</i></h3>
        </div>
        <p data-aos="fade-in" data-aos-duration="2000" class="pt-[12px] md:pt-3 pb-3 md:pr-4 font-medium uppercase text-center text-base md:text-xl text-prime-color font-sans">Thông tin mới nhất</p>
        <div v-if="!loading" class="container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[16px]">
            <div v-for="(news, index) in mainNews" :key="index">
                <div class="bg-white w-full h-fit shadow-lg shadow-black relative">
                    <img :src="$addPrefix(news.image)" class="w-full h-[200px] object-cover object-center cursor-pointer" alt="news-thumbnail" @click="pushNewsDetail(news._id)">
                    <div class="px-[8px] py-3 md:px-3 flex flex-col gap-2">
                        <h4 class="mb-0 font-semibold cursor-pointer truncate" @click="pushNewsDetail(news._id)">{{ news.name }}</h4>
                        <p class="line-clamp-2 w-full mb-0" v-html="news.description"></p>
                        <div class="flex justify-between">
                            <p class="mb-0 text-gray-400 font-semibold">{{ getDateTime(news.updatedAt) }}</p>
                            <p class="mb-0 pr-2 hover:text-prime-color cursor-pointer font-semibold" @click="pushNewsDetail(news._id)">Đọc ngay</p>
                        </div>
                    </div>
                    <b-badge variant="warning" class="absolute top-3 left-3"><h6 class="mb-0 font-semibold">{{ news.type }}</h6></b-badge>
                </div>
            </div>
            <div class="w-full h-full bg-white shadow-lg shadow-black relative sm:col-span-2 lg:col-span-1">
                <p class="mb-0 text-center bg-prime-color text-xl font-semibold text-white py-1">Các tin tức gần đây</p>
                <div class="bg-white">
                    <div 
                        class="flex justify-between border-prime-color hover:bg-gray-100 px-3 py-[2px] " 
                        :class="{'border-b-[1px]' : (index+1) != subNews.length}" 
                        v-for="(news, index) in subNews" :key="index"
                        @click="pushNewsDetail(news._id)">
                        <div class="flex flex-col">
                            <p class="mb-0 font-semibold cursor-pointer truncate">{{ news.name }}</p>
                            <p class="mb-0">{{ news.type }}</p>
                        </div>
                        <p class="mb-0 my-auto text-gray-400 font-semibold">{{ getDateTime(news.updatedAt) }}</p>
                    </div>
                    <button @click="()=>{this.$router.push({name: 'user.news'})}" class="w-full py-[8px] lg:py-0 lg:h-full text-prime-color hover:text-red-800 cursor-pointer text-xl font-semibold">Xem thêm</button>
                </div>
            </div>
        </div>
        <Loading v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import Loading from '@/components/loading'

export default {
    components: {
        Loading
    },
    data() {
        return {
            mainNews: [],
            subNews: [],
            loading: true
        }
    },
    methods: {
        ...mapActions('news', ['GetLatestNewsList']),
        async getEntry(){
            let response = await this.GetLatestNewsList()
            this.mainNews = response.data.data.slice(0,2)
            this.subNews = response.data.data.slice(-5)
            this.loading = false
        },
        getDateTime(rawData) {
            return rawData.substring(8, 10) + '-' + rawData.substring(5, 7) + '-' + rawData.substring(0, 4)
        },
        pushNewsDetail(id) {
            this.$router.push({path: '/news/detail/' + id})
        }
    },
    created() {
        this.loading = false
        this.getEntry()
    },
}
</script>